import { Config } from '../config';
import { CameraVersion } from '../interfaces';
import { HttpService } from './http.service';

const path = `${Config.API}/devices/camera_versions`;

interface CreateCameraVersionPayload {
  version_name: string;
}

export abstract class CameraVersionsService {
  /**
   * Get all camera versions
   */
  public static getCameraVersions = (): Promise<CameraVersion[]> => {
    return HttpService.fetchAuthorized(path).then((res) => res);
  };

  /**
   * Create a new camera version
   * @param payload
   */
  public static createCameraVersion = (payload: CreateCameraVersionPayload): Promise<any> => {
    return HttpService.fetchAuthorized(
      path,
      {
        method: 'POST',
        body: JSON.stringify(payload),
      },
      null,
      true,
    ).then((res) => res);
  };

  /**
   * Delete a camera version by id
   * @returns Promise<void>
   */
  public static deleteCameraVersion = (cameraVersionId: number): Promise<void> => {
    return HttpService.fetchAuthorized(
      `${path}/${cameraVersionId}`,
      {
        method: 'DELETE',
      },
      null,
      true,
    ).then((res) => res);
  };
}
